import { createSelector } from '@ngrx/store';
import { TMachineMaintenanceState } from '../reducers';
import { TBreakdownReasonsState } from './breakdown-reasons.models';

export const getBreakdownReasonsState = (state: TMachineMaintenanceState) => state.breakdownReasonsInfo;

export const getBreakdownReasonsPagination = createSelector(
  getBreakdownReasonsState,
  (state: TBreakdownReasonsState) => state.breakdownReasonsPagination,
);

export const getBreakdownReasonsListInfo = createSelector(
  getBreakdownReasonsState,
  (state: TBreakdownReasonsState) => state.breakdownReasonsListingInfo,
);

export const getBreakdownReasonsDropdownInfo = createSelector(
  getBreakdownReasonsState,
  (state: TBreakdownReasonsState) => state.breakdownReasonsDropdown,
);
